import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserModel } from '@shared/types/user';

@Injectable({
  providedIn: 'root',
})
export class UserState {
  public user$ = new BehaviorSubject<UserModel>(null);
  public userIsLogin$ = new BehaviorSubject<boolean>(false);

  constructor() {}
}
